import Vue from "vue";
import VueRouter from "vue-router";
import HomePage from "../components/home/HomePage";
import AcessoCandidato from "../components/acesso/AcessoCandidato.vue";
import InscricaoView from "@/views/InscricaoView.vue";
import MinhasAreasInteresseView from "@/views/MinhasAreasInteresseView.vue";
import MinhasExperienciasProfView from "@/views/MinhasExperienciasProfView.vue";
import MeusDadosPessoaisView from "@/views/MeusDadosPessoaisView.vue";
import EnviarDocumentacoesView from "@/views/EnviarDocumentacoesView";
import { isProducao } from "@/global";
import store from "@/store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    component: HomePage,
    meta: {
      requiresAuth: false,
      minLevel: 0,
      maxLevel: 999,
    },
  },
  {
    path: "/acesso",
    name: "acesso",
    component: AcessoCandidato,
    meta: {
      requiresAuth: false,
      minLevel: 0,
      maxLevel: 999,
    },
  },
  {
    path: "/acesso-aprendiz-industrial",
    name: "Aprendiz industrial",
    component: AcessoCandidato,
    meta: {
      requiresAuth: false,
      minLevel: 0,
      maxLevel: 999,
    },
  },
  {
    path: "/inscricao",
    name: "Inscrição",
    component: InscricaoView,
    meta: {
      requiresAuth: true,
      minLevel: 0,
      maxLevel: 1,
    },
  },
  {
    path: "/bne",
    name: "bne",
    meta: {
      requiresAuth: false,
      minLevel: 0,
      maxLevel: 999,
    },
    beforeEnter() {
      window.open("https://www.bne.com.br/jobs/coasul");
    },
  },
  {
    path: "/jovem-aprendiz",
    name: "jovem-aprendiz",
    beforeEnter() {
      if (isProducao())
        window.open("https://www.coasul.com.br/inscricao/jovem-aprendiz/#/");
      else
        window.open("http://192.168.1.187/trabalhe-conosco/jovem-aprendiz/#/");
    },
  },
  {
    path: "/meus-dados-pessoais",
    name: "Meus Dados Pessoais",
    component: MeusDadosPessoaisView,
    meta: {
      requiresAuth: true,
      minLevel: 2,
      maxLevel: 999,
    },
  },
  {
    path: "/minhas-areas-interesse",
    name: "Minhas Áreas de Interesse",
    component: MinhasAreasInteresseView,
    meta: {
      requiresAuth: true,
      minLevel: 2,
      maxLevel: 999,
    },
  },
  {
    path: "/minhas-experiencias-profissionais",
    name: "Minhas Experiências Profissionais",
    component: MinhasExperienciasProfView,
    meta: {
      requiresAuth: true,
      minLevel: 2,
      maxLevel: 999,
    },
  },
  {
    path: "/documentacao",
    name: "Documentação",
    component: EnviarDocumentacoesView,
    meta: {
      requiresAuth: true,
      minLevel: 2,
      maxLevel: 999,
    },
  },
];

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.path == "/acesso") {
    sessionStorage.removeItem("aprendiz-industrial");
  } else if (to.path == "/acesso-aprendiz-industrial") {
    sessionStorage.setItem("aprendiz-industrial", true);
  }

  await store.dispatch("refreshCandidato");

  if (store.state.candidato == null || store.state.candidato == undefined) {
    if (to.meta.requiresAuth) {
      if (store.state.aprendiz_industrial) {
        next({ path: "/acesso-aprendiz-industrial" });
      } else {
        next({ path: "/acesso" });
      }
    }
  } else if (!to.meta.requiresAuth) {
    next({ path: "/inscricao" });
  } else if (
    store.state.candidato.nivel < to.meta.minLevel ||
    store.state.candidato.nivel > to.meta.maxLevel
  ) {
    if (store.state.candidato.nivel < 2) next("/inscricao");
    else next("/documentacao");
  }

  next();
});

export default router;
